module.exports = __webpack_public_path__ + "static/media/arrow-right.d1fd34f0.svg";